import { render, staticRenderFns } from "./HcmFooter.vue?vue&type=template&id=67004382&scoped=true"
import script from "./HcmFooter.js?vue&type=script&lang=js&external"
export * from "./HcmFooter.js?vue&type=script&lang=js&external"
import style0 from "./HcmFooter.scss?vue&type=style&index=0&id=67004382&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67004382",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotHcmLists: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmLists/HcmLists.vue').default,HotHcmMadeWithLove: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmMadeWithLove/HcmMadeWithLove.vue').default,HotHcmNavSocial: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmNavSocial/HcmNavSocial.vue').default,HotHcmLanguageSwitch: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Molecules/HcmLanguageSwitch/HcmLanguageSwitch.vue').default})
